import React from 'react';
import { USER_TYPES } from '../constants/user';
import { PAGE_CLASSIFICATION } from '../constants';
import {
  Maps,
  Observations,
  Farm,
  ObservationList,
  User,
  Client,
  Configuration,
  ConfigurationView,
  CreateConfiguration,
  FarmHistory,
  Crops,
  CropStages,
  CropVarieties,
  Farmers,
  FeedbackQuestions,
  FeedbackReport,
  FeedbackResponses,
  CreateInfestation,
  DeviceRequests,
  FieldAgents,
  FieldLocations,
  Infestation,
  InfestationParameters,
  InfestationSymptoms,
  InfestationLevelDetails,
  Notifications,
  SmsNotifications,
  PracticeCalendar,
  Project,
  UserProfile,
  // ProductRecommendation,
  // ProductsCatalogue,
  SoilTypes,
  Schemes,
  CreateScheme,
  AnalyticsDashboard,
  SignIn,
  ForgotPassword,
  ResetPassword,
} from './pages';
import clientConfig from '../assets/svgDrawer/svgs/clientConfig.svg';
import clientDashboard from '../assets/svgDrawer/svgs/clientDashboard.svg';
import projects from '../assets/svgDrawer/svgs/projects.svg';
import projects_color from '../assets/svgDrawer/svgs/projects_color.svg';
import infestations from '../assets/svgDrawer/svgs/infestations.svg';
import infestations_color from '../assets/svgDrawer/svgs/infestations_color.svg';
import farm from '../assets/svgDrawer/svgs/farm.svg';
import farm_color from '../assets/svgDrawer/svgs/farm_color.svg';
import crops from '../assets/svgDrawer/svgs/crops.svg';
import crops_color from '../assets/svgDrawer/svgs/crops_color.svg';
import soiltype from '../assets/svgDrawer/svgs/soiltype.svg';
import soiltype_color from '../assets/svgDrawer/svgs/soiltype_color.svg';
import feedback from '../assets/svgDrawer/svgs/feedback.svg';
import feedback_color from '../assets/svgDrawer/svgs/feedback_color.svg';
import clientConfig_color from '../assets/svgDrawer/svgs/clientConfig_color.svg';
import clientDashboard_color from '../assets/svgDrawer/svgs/clientDashboard_color.svg';
import device_manager from '../assets/svgDrawer/svgs/device_manager.svg';
import device_manager_color from '../assets/svgDrawer/svgs/device_manager_color.svg';
import notifications from '../assets/svgDrawer/svgs/notifications.svg';
import notifications_color from '../assets/svgDrawer/svgs/notifications_color.svg';
import farm_map from '../assets/svgDrawer/svgs/farm_map.svg';
import farm_map_color from '../assets/svgDrawer/svgs/farm_map_color.svg';
import infestation_map from '../assets/svgDrawer/svgs/infestation_map.svg';
import infestation_map_color from '../assets/svgDrawer/svgs/infestation_map_color.svg';
import master_data from '../assets/svgDrawer/svgs/master_data.svg';
import master_data_color from '../assets/svgDrawer/svgs/master_data_color.svg';
import observations from '../assets/svgDrawer/svgs/observations.svg';
import observations_color from '../assets/svgDrawer/svgs/observations_color.svg';
import farmer from '../assets/svgDrawer/svgs/farmer.svg';
import farmer_color from '../assets/svgDrawer/svgs/farmer_color.svg';
import web_user from '../assets/svgDrawer/svgs/web_user.svg';
import web_user_color from '../assets/svgDrawer/svgs/web_user_color.svg';
import field_locations from '../assets/svgDrawer/svgs/field_locations.svg';
import field_locations_color from '../assets/svgDrawer/svgs/field_locations_color.svg';
import manageClients from '../assets/svgDrawer/svgs/manageClients.svg';
import manageClients_color from '../assets/svgDrawer/svgs/manageClients_color.svg';
import infestation_parameters from '../assets/svgDrawer/svgs/infestation_parameters.svg';
import infestation_parameters_color from '../assets/svgDrawer/svgs/infestation_parameters_color.svg';
import maps from '../assets/svgDrawer/svgs/maps.svg';
import maps_color from '../assets/svgDrawer/svgs/maps_color.svg';

export const APP_ROUTES = [
  {
    path: '/',
    element: <AnalyticsDashboard />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Dashboard',
    sidebarLabel: 'Dashboard',
    sidebarIcon: clientDashboard,
    sidebarIconColor: clientDashboard_color,
    priority: 1,
  },
  {
    path: '/manage-clients',
    element: <Client />,
    roles: [USER_TYPES.superuser],
    title: 'Client Management',
    sidebarLabel: 'Clients',
    sidebarIcon: clientConfig,
    sidebarIconColor: clientConfig_color,
    priority: 2,
  },
  {
    path: '/manage-projects',
    element: <Project />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Project Management',
    sidebarLabel: 'Projects',
    sidebarIcon: projects,
    sidebarIconColor: projects_color,
    priority: 3,
  },
  {
    path: '/crops',
    element: <Crops />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'Crops',
    sidebarLabel: 'Crops',
    sidebarIcon: crops,
    sidebarIconColor: crops_color,
    priority: 7,
  },
  {
    path: '/infestation',
    element: <Infestation />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'Infestations',
    pageClassification: PAGE_CLASSIFICATION.infestationPrediction,
    sidebarLabel: 'Infestations',
    sidebarIcon: infestations,
    sidebarIconColor: infestations_color,
    priority: 8,
  },
  {
    path: '/configurations',
    element: <Configuration />,
    roles: [USER_TYPES.superuser],
    title: 'Configurations',
    sidebarLabel: 'Configuration',
    sidebarIcon: clientConfig,
    sidebarIconColor: clientConfig_color,
    sidebarKey: 'configuration',
    priority: 10,
  },
  {
    path: '/configuration',
    element: <ConfigurationView />,
    roles: [USER_TYPES.superadmin],
    title: 'Configuration',
    sidebarLabel: 'Configuration',
    sidebarIcon: clientConfig,
    sidebarIconColor: clientConfig_color,
    sidebarKey: 'configuration',
    priority: 10,
  },
  {
    path: '/configuration/edit',
    element: <CreateConfiguration />,
    roles: [USER_TYPES.superadmin],
    title: 'Configuration',
    priority: 11,
  },
  {
    path: '/configurations/:client_id',
    element: <ConfigurationView />,
    roles: [USER_TYPES.superuser],
    title: 'Configuration',
    priority: 11,
  },
  /*{
    path: '/product-rec',
    element: <ProductRecommendation />,
    roles: [USER_TYPES.superuser],
    title: 'Product Recommendations',
    sidebarLabel: 'Products',
    sidebarGroup: 'Products',
    sidebarIcon: products,
    sidebarIconColor: products_color,
  },*/
  {
    path: '/soil-types',
    element: <SoilTypes />,
    roles: [USER_TYPES.superuser],
    title: 'Soil Types',
    sidebarLabel: 'Soil Types',
    sidebarGroup: 'Master Data',
    sidebarIcon: soiltype,
    sidebarIconColor: soiltype_color,
  },
  /*{
    path: '/feedback/!*',
    element: <Feedback />,
    roles: [USER_TYPES.superuser],
    title: '',
  },*/
  {
    path: '/feedback/report',
    element: <FeedbackReport />,
    roles: [USER_TYPES.superuser],
    title: 'Feedback Report',
  },
  {
    path: '/infestation-parameters',
    element: <InfestationParameters />,
    roles: [USER_TYPES.superuser],
    title: 'Infestation Parameters',
    pageClassification: PAGE_CLASSIFICATION.infestationPrediction,
    sidebarLabel: 'Infestation Parameters',
    sidebarGroup: 'Master Data',
    sidebarIcon: master_data,
    sidebarIconColor: master_data_color,
  },
  {
    path: '/schemes',
    element: <Schemes />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Schemes',
    pageClassification: PAGE_CLASSIFICATION.govtSchemes,
    sidebarLabel: 'Schemes',
    sidebarGroup: 'Master Data',
    sidebarIcon: master_data,
    sidebarIconColor: master_data_color,
  },
  {
    path: '/schemes/create',
    element: <CreateScheme />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Create Scheme',
    pageClassification: PAGE_CLASSIFICATION.govtSchemes,
  },
  {
    path: '/schemes/edit/:id',
    element: <CreateScheme />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Edit Scheme',
    pageClassification: PAGE_CLASSIFICATION.govtSchemes,
  },
  {
    path: '/infestation/create',
    element: <CreateInfestation />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin],
    title: 'Create Infestations',
    pageClassification: PAGE_CLASSIFICATION.infestationPrediction,
  },
  {
    path: '/maps',
    element: <Maps />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'Map View',
    pageClassification: PAGE_CLASSIFICATION.infestationPrediction,
    sidebarLabel: 'Infestation Prediction Map',
    sidebarGroup: 'Map',
    sidebarIcon: infestation_map,
    sidebarIconColor: infestation_map_color,
  },
  {
    path: '/maps/farm',
    element: <Maps />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Map View',
    pageClassification: PAGE_CLASSIFICATION.farmers,
    sidebarLabel: 'Farm Map',
    sidebarGroup: 'Map',
    sidebarIcon: farm_map,
    sidebarIconColor: farm_map_color,
  },
  {
    path: '/manage-users',
    element: <User />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'User Management',
    sidebarLabel: 'Web Users',
    sidebarGroup: 'Users',
    sidebarIcon: web_user,
    sidebarIconColor: web_user_color,
  },
  {
    path: '/manage-farmers',
    element: <Farmers />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Farmer Management',
    pageClassification: PAGE_CLASSIFICATION.farmers,
    sidebarLabel: 'Farmers',
    sidebarGroup: 'Users',
    sidebarIcon: farmer,
    sidebarIconColor: farmer_color,
  },
  {
    path: '/manage-field-agents',
    element: <FieldAgents />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Field Agent Management',
    pageClassification: PAGE_CLASSIFICATION.fieldAgents,
    sidebarLabel: 'Field Agents',
    sidebarGroup: 'Users',
    sidebarIcon: web_user,
    sidebarIconColor: web_user_color,
  },
  /*{
    path: '/product',
    element: <ProductsCatalogue />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Product Management',
    sidebarLabel: 'Products',
    sidebarIcon: products,
    sidebarIconColor: products_color,
  },*/
  {
    path: '/infestation/infestation-level-details/:id',
    element: <InfestationLevelDetails />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'Infestation Level Details',
    pageClassification: PAGE_CLASSIFICATION.infestationPrediction,
  },
  {
    path: '/infestation-symptoms/:id',
    element: <InfestationSymptoms />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'Infestation Symptoms',
    pageClassification: PAGE_CLASSIFICATION.infestationPrediction,
  },
  {
    path: '/user-profile',
    element: <UserProfile />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'User Profile',
  },
  {
    path: '/crop-varieties/:id',
    element: <CropVarieties />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'Crop Varieties',
  },
  {
    path: '/practice-calendar/:id',
    element: <PracticeCalendar />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'Practice Calendar',
  },
  {
    path: '/farms',
    element: <Farm />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Farms',
    pageClassification: PAGE_CLASSIFICATION.farmers,
    sidebarLabel: 'Farms',
    sidebarGroup: 'Farms',
    sidebarIcon: farm,
    sidebarIconColor: farm_color,
  },
  {
    path: '/field-locations',
    element: <FieldLocations />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Field Locations',
    pageClassification: PAGE_CLASSIFICATION.fieldAgents,
    sidebarLabel: 'Field Locations',
    sidebarGroup: 'Farms',
    sidebarIcon: field_locations,
    sidebarIconColor: field_locations_color,
  },
  {
    path: '/observations',
    element: <Observations />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'Observations',
    pageClassification: [
      PAGE_CLASSIFICATION.fieldAgents,
      PAGE_CLASSIFICATION.farmers,
    ],
    sidebarLabel: 'Observations',
    sidebarGroup: 'Farms',
    sidebarIcon: observations,
    sidebarIconColor: observations_color,
  },
  {
    path: '/farm-history/:farmId',
    element: <FarmHistory />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Farm History',
    pageClassification: PAGE_CLASSIFICATION.farmers,
  },
  {
    path: '/observation-list/:entity_id',
    element: <ObservationList />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'Observations List',
    pageClassification: [
      PAGE_CLASSIFICATION.fieldAgents,
      PAGE_CLASSIFICATION.farmers,
    ],
  },
  {
    path: '/feedback/questions',
    element: <FeedbackQuestions />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Feedback Questions',
    sidebarLabel: 'Feedback Master',
    sidebarGroup: 'Master Data',
    sidebarIcon: feedback,
    sidebarIconColor: feedback_color,
  },
  {
    path: '/feedback/responses',
    element: <FeedbackResponses />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Feedback Responses',
    sidebarLabel: 'User Feedback',
    sidebarGroup: 'Users',
    sidebarIcon: feedback,
    sidebarIconColor: feedback_color,
  },
  {
    path: '/device',
    element: <DeviceRequests />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Device Requests',
    sidebarLabel: 'Device Manager',
    sidebarGroup: 'Users',
    sidebarIcon: device_manager,
    sidebarIconColor: device_manager_color,
  },
  {
    path: '/notifications',
    element: <Notifications />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'Notifications',
    sidebarLabel: 'Notifications',
    sidebarGroup: 'Users',
    sidebarIcon: notifications,
    sidebarIconColor: notifications_color,
  },
  {
    path: '/sms-notifications',
    element: <SmsNotifications />,
    roles: [USER_TYPES.superuser, USER_TYPES.superadmin, USER_TYPES.admin],
    title: 'SMS Notifications',
    pageClassification: PAGE_CLASSIFICATION.smsNotifications,
    sidebarLabel: 'SMS Notifications',
    sidebarGroup: 'Users',
    sidebarIcon: notifications,
    sidebarIconColor: notifications_color,
  },
  {
    path: '/crop-stages/:crop_id',
    element: <CropStages />,
    roles: [
      USER_TYPES.superuser,
      USER_TYPES.superadmin,
      USER_TYPES.admin,
      USER_TYPES.user,
    ],
    title: 'Crop Stages',
  },
];

export const SIDEBAR_GROUPS = [
  {
    label: 'Users',
    icon: manageClients,
    icon_color: manageClients_color,
    sidebarGroup: 'Users',
    priority: 4,
  },
  {
    label: 'Farms',
    icon: farm,
    icon_color: farm_color,
    sidebarGroup: 'Farms',
    priority: 5,
  },
  {
    label: 'Map View',
    icon: maps,
    icon_color: maps_color,
    sidebarGroup: 'Map',
    priority: 6,
  },
  {
    label: 'Master Data',
    icon: infestation_parameters,
    icon_color: infestation_parameters_color,
    sidebarGroup: 'Master Data',
    priority: 9,
  },
];

export const PUBLIC_ROUTES = {
  '/sign-in': <SignIn />,
  '/forgot-password': <ForgotPassword />,
  '/reset-password': <ResetPassword />,
};

export const REDIRECT_MAP = {
  [USER_TYPES.superuser]: '/',
  [USER_TYPES.superadmin]: '/',
  [USER_TYPES.admin]: '/',
};
